module.exports = __webpack_public_path__ + "assets/img/logo.bbeab1be.png";